import React from 'react';

const CrownIcon = () => (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none">
    <path
      d="M4 17.7305H18M1 1.73053L4 13.7305H18L21 1.73053L15 8.73053L11 1.73053L7 8.73053L1 1.73053Z"
      stroke="#E08700"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default CrownIcon;
